const describeAppFundaBrochureRequestNewCondition = (): string =>
  'een nieuw Funda brochureverzoek is aangevraagd';

export default describeAppFundaBrochureRequestNewCondition;
